const isAdditionalChargeApplicable = charges => {
  if (Array.isArray(charges)) {
    return charges.some(amount => amount === null);
  }

  return false;
};

export default isAdditionalChargeApplicable;
